import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request, {
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../api/request';
import { AccountType } from '../../../types/account';
import {
  ContinuousEducationSectionClassroomLoaderFilters,
  ContinuousEducationSectionEditResponse,
  ContinuousEducationSectionSchedulesResponse,
  UpdateContinuousEducationSectionSchedules,
  UpdateContinuousEducationSectionBody,
} from './types';

export const getContinuousEducationSectionActionRequest = (
  id: string | number,
) => {
  return request<ContinuousEducationSectionEditResponse>(
    CONTINUOUS_EDUCATION.SECTION(id),
  );
};

export const getContinuousEducationSectionSchedulesActionRequest = (
  id: string | number,
) => {
  return request<ContinuousEducationSectionSchedulesResponse>(
    CONTINUOUS_EDUCATION.SECTION_SCHEDULES(id),
  );
};

export const updateContinuousEducationSectionSchedulesActionRequest = (
  id: string | number,
  data: UpdateContinuousEducationSectionSchedules,
) => {
  return request<ContinuousEducationSectionSchedulesResponse>(
    CONTINUOUS_EDUCATION.SECTION_SCHEDULES(id),
    {
      method: 'put',
      data,
    },
  );
};

export const getClassroomAvailabilityActionRequest = ({
  sectionId,
  ...params
}: ContinuousEducationSectionClassroomLoaderFilters & {
  sectionId: number | string;
}) => {
  const { sectionScheduleId, ...requiredFilters } = params;
  if (Object.values(requiredFilters).some((value) => value === undefined)) {
    return Promise.resolve<AxiosResult<any[], AxiosResultDefaultError>>(
      [] as any,
    );
  }
  return request<any[]>(
    CONTINUOUS_EDUCATION.SECTIONS_SCHEDULES_GET_CLASSROOM_AVAILABILITY,
    {
      params,
    },
  );
};

export const getEditResponsiblesActionRequest = (searchText: string) => {
  return request<AccountType[]>(
    CONTINUOUS_EDUCATION.SECTIONS_SCHEDULES_SEARCH_RESPONSABLE,
    {
      params: { search_text: searchText },
    },
  );
};

export const updateContinuousEducationSectionActionRequest = (
  id: string | number,
  data: UpdateContinuousEducationSectionBody,
) => {
  return request(CONTINUOUS_EDUCATION.SECTION(id), {
    method: 'PUT',
    data,
  });
};
